import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { JWT_OPTIONS, JwtModule } from '@auth0/angular-jwt';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NgMapsCoreModule } from '@ng-maps/core';
import { NgMapsGoogleModule, GOOGLE_MAPS_API_CONFIG } from '@ng-maps/google';
import { DeniedComponent } from './components/denied/denied.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';
import { ShellComponent } from './components/shell/shell.component';
import { AuthGuard } from './guards/auth.guard';
import { ShellEffects } from './state/shell.effects';
import { safeShellReducer } from './state/shell.store';
import { CallbackComponent } from './components/callback/callback.component';

const routes: Routes = [
    { path: '', redirectTo: 'send', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'denied', component: DeniedComponent },
    { path: 'callback', component: CallbackComponent },
    { path: 'send', canActivate: [AuthGuard], loadChildren: () => import('../../module.send').then(m => m.SendModule) }
];

@NgModule({
    declarations: [LoginComponent, LogoutComponent, ShellComponent, DeniedComponent],
    exports: [],
    bootstrap: [ShellComponent], imports: [BrowserModule,
        ReactiveFormsModule,
        JwtModule.forRoot({
            jwtOptionsProvider: {
                provide: JWT_OPTIONS,
                useFactory: () => {
                    const config = {
                        authScheme: '',
                        tokenGetter: () => localStorage.getItem('auth_token'),
                        skipWhenExpired: true,
                        whitelistedDomains: ['mobile.workbuddy.app', 'mobile.workbuddy.dev', 'mobile.workbuddy.io']
                    };
                    return config;
                }
            }
        }),
        RouterModule.forRoot(routes, { useHash: true }),
        StoreModule.forRoot({ shell: safeShellReducer }, {
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
                strictStateSerializability: true,
                strictActionSerializability: true,
            }
        }),
        EffectsModule.forRoot([ShellEffects]),
        StoreDevtoolsModule.instrument({ maxAge: 10 }),
        NgMapsCoreModule,
        NgMapsGoogleModule], providers: [
            {
                provide: GOOGLE_MAPS_API_CONFIG,
                useValue: {
                    libraries: ['places', 'geometry'],
                    apiKey: 'AIzaSyDt4V-cqVtzIZHHjGnTshkv6cNsRvA8FJI'
                }
            },
            provideHttpClient(withInterceptorsFromDi()),
        ]
})
export class ShellModule { }
